var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"pt-10 pb-32 bg-emerald-700"},[_c('div',{staticClass:"max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8"},[_c('h1',{staticClass:"text-3xl leading-9 font-bold text-white capitalize"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }